import Inputmask from "inputmask"

window.onload = function(){
  let cpf_field = document.getElementById('patient_identification_cpf');
  let input_mask = new Inputmask("999.999.999-99");
  let CPF = require('cpf');
  let identify_patient_form_submit_btn = document.querySelector('#identify_patient_form_submit');

  input_mask.mask(cpf_field);
  identify_patient_form_submit_btn.addEventListener('click', handleSubmit)

  function handleSubmit(e){
    cpf_field.setCustomValidity('');
    if(cpf_field.validity.valid){
      if(!CPF.isValid(cpf_field.value)){
        cpf_field.setCustomValidity('CPF Inválido');
      }
    }
    
  }
}
